<template>
    <div class="card h-100">
      <div class="card-body text-center d-flex flex-column justify-content-between align-items-center"
          style="padding-top: 0rem !important;">
        <div>
          <div class="mt-4 position-relative">
            <img
              class="avatar rounded-circle"
              src="/img/persons/avatar-muted.png"
              :alt="user.name"
            />
          </div>
          <div class="col">
            <label class="mt-2 user-name">{{ user.name }}</label>
            <icon-male-light v-if="user.gender == 'M'" alt="Male"  />
            <icon-female-light v-if="user.gender == 'F'" alt="Female" />
          </div>
          <div class="mt-1 text-uppercase text-muted" style="font-size: 1rem;">
           {{ user.section ? user.section.name : "" }}
          </div>
          <div class="container" style="padding-top: 2rem">
            <div class="row justify-content-between" style="gap: 0.2rem">
                <div class="col text-start justify-content-between">
                    <span class="data-label">Height</span>
                    <label class="data-value">
                      {{ user.height_cm }} cm
                    </label>
                </div>
                <div class="col text-start justify-content-between">
                    <span class="data-label">Age</span>
                    <label class="data-value">{{ user.age }}</label>
                </div>
                <div class="w-100"></div>
                <div class="col text-start justify-content-between">
                    <span class="data-label">Weight</span>
                    <label class="data-value">
                      {{ user.weight_kg }} kg
                    </label>
                </div>
                <div class="col text-start">
                    <span class="data-label">DOB</span>
                    <label class="data-value">
                      {{ formatDateOfBirth(user.date_of_birth) }}
                    </label>
                </div>
                <div class="w-100"></div>
                <div class="col text-start justify-content-between">
                    <span class="data-label">BMI</span>
                    <span class="data-value" style="padding-left: 1rem;padding-right: 1rem;">
                      {{ user.bmi ? user.bmi.value : "-" }}
                    </span>
                    <span style="border-radius: 0.4rem;"
                        class="text-center text-sm text-uppercase text-black font-weight-bold px-2 py-1"
                        :class="getBmiCategoryColor(user.bmi.category)"
                        >{{
                          user.bmi && user.bmi.category ? user.bmi.category : ""
                        }}</span>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import IconMaleLight from "@/shared/Controls/Icons/IconMaleLight.vue";
  import IconFemaleLight from "@/shared/Controls/Icons/IconFemaleLight.vue";
  import Utils from "@/helpers/utils.js";
  import dayjs from "dayjs";

  export default {
    name: "UserDetailsCard",
    components: {
      IconMaleLight,
      IconFemaleLight,
    },
    props: {
      user: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {};
    },
    methods: {
        getBmiCategoryColor() {
        if (this.user?.bmi?.category) {
            return Utils.getBmiCategoryColor(this.user.bmi.category);
        }
        return "";
        },
        formatDateOfBirth(dt) {
            return dayjs(dt).format("DD MMM YYYY");
        },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .avatar {
    width: 64px;
    height: 64px;
  }
  .data-label {
    color: #bce1da;
    text-align: end;
    font-weight: 500;
    font-size: 1rem;
    padding-right: 0.5rem;
  }
  .data-value {
    color: #f2f2f2;
    font-weight: 500;
    font-size: 0.95rem;
  }
  .user-name {
    font-size: 1rem;;
    font-weight: 500;
    padding-right: 0.2rem;
    margin: 0;
  }
  </style>
  